import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Content Section API
export const contentAPI = {
  getSection: async (sectionName) => {
    const response = await axios.get(`${API_URL}/content/${sectionName}`);
    return response.data;
  },
  
  getAllSections: async () => {
    const [hero, mission, music, cta] = await Promise.all([
      contentAPI.getSection('hero').catch(() => null),
      contentAPI.getSection('mission').catch(() => null),
      contentAPI.getSection('music').catch(() => null),
      contentAPI.getSection('cta').catch(() => null),
    ]);
    return { hero, mission, music, cta };
  }
};

// Products API
export const productsAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/products`);
    return response.data;
  },
  
  getFeatured: async () => {
    const response = await axios.get(`${API_URL}/products/featured`);
    return response.data;
  }
};

// Events API
export const eventsAPI = {
  getUpcoming: async () => {
    const response = await axios.get(`${API_URL}/events/upcoming`);
    return response.data;
  },
  
  getPast: async () => {
    const response = await axios.get(`${API_URL}/events/past`);
    return response.data;
  }
};

// Media API
export const mediaAPI = {
  getByCategory: async (category) => {
    const response = await axios.get(`${API_URL}/media`, {
      params: { category }
    });
    return response.data;
  },
  
  getAll: async () => {
    const response = await axios.get(`${API_URL}/media`);
    return response.data;
  }
};
